import { useNavigate } from 'react-router';

import { useCheckAuthTimer, useJWT } from '@jane/shared/auth';

import { useCustomerDispatch } from '../customer/dispatch';
import { handleInvalidLoginToken } from '../customer/redux/customer';

export const CheckAuthTimer = () => {
  const bearerToken = useJWT();
  const navigate = useNavigate();
  const dispatch = useCustomerDispatch();
  useCheckAuthTimer(bearerToken, () =>
    dispatch(handleInvalidLoginToken(false, navigate))
  );

  return null;
};
